@if (params.data.tenantStatus === 'Archived' && (params.data.role === 'Admin' || IsOwner)) {
  <div class="action-menu">
    <ra-ui-text-button
      label="Restore"
      id="restoreButton"
      icon="ra-icon-ide-md-undo"
      (onClick)="restoreOrganization(params.data)"
    >
    </ra-ui-text-button>
  </div>
} @else if (params.data.tenantStatus === 'Active' && menuItems.length) {
  <span class="action-menu"
    ><i
      class="ra-icon-ide-sm-kebob"
      [ngClass]="{
        disabled:
          params.data.role !== 'Admin' && params.data.role !== 'Owner' && params.data.tenantStatus === 'Archived',
      }"
      [raUiMenuTriggerFor]="menu"
      #menuTrigger="raUiMenuTriggerFor"
      (click)="onKebabClick()"
    ></i>
  </span>
} @else if (!params.data.role && isFromSubOrgPage) {
  <div class="action-menu">
    <ra-ui-text-button
      class="join-btn"
      [config]="{
        displayIconAfterText: false,
      }"
      icon="ra-icon-ide-sm-plus"
      label="Join"
      (click)="joinSubOrg(params.data)"
    >
    </ra-ui-text-button>
  </div>
}

<ra-ui-menu #menu [items]="menuItems" (onClick)="onMenuItemClick($event)">
  <ng-template #item let-model="item">
    <div class="menu-item-wrap">
      <div class="menu-item" [ngClass]="{ disabled: model.disabled }">
        {{ model.label }}
      </div>

      <i
        [raUiTooltip]="model.tooltip"
        [tooltipConfig]="tooltipConfig"
        *ngIf="model.tooltip"
        id="ra-icon-ide-md-info"
        class="ra-icon-ide-md-info"
      >
      </i>
    </div>
  </ng-template>
</ra-ui-menu>

<ng-template #leaveOrgModal>
  <app-leave-org-modal [orgName]="params.data.name" [isFromSubOrgPage]="isFromSubOrgPage"></app-leave-org-modal>
</ng-template>

@if (selectedTenant$ | async) {}
